// ============================================================
// MUI Theme — Light Mode
// ============================================================
// Dark mode can be added by creating a darkPalette and toggling
// based on themeStore.mode without any structural changes.

import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { shadows } from './shadows';
import { components } from './components';
import { tokens } from './tokens';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    ...palette,
  },
  typography,
  shadows,
  components,
  shape: {
    borderRadius: parseInt(tokens.radius.sm),
  },
  breakpoints: {
    values: tokens.breakpoints,
  },
  zIndex: {
    appBar: tokens.zIndex.topbar,
    drawer: tokens.zIndex.sidebar,
    modal: tokens.zIndex.modal,
    tooltip: tokens.zIndex.tooltip,
    snackbar: tokens.zIndex.toast,
  },
});

// Future: export const darkTheme = createTheme({ palette: { mode: 'dark', ...darkPalette }, ... });

export { tokens } from './tokens';
